import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import branchesLogStore from 'src/view/screens/BranchLogScreen/screens/BranchesLogScreen/store/branchesLogStore';
import { reportsStore } from '~/view/screens/ReportsScreen/store/reportsStore';
import ReportsCalendar from '~/view/screens/ReportsScreen/components/ReportsCalendar/ReportsCalendar';
import BranchPicker from '~/view/components/Controls/Pickers/BranchPicker/BranchPicker';
import { branchStore } from '~/mobx/branchStore';
import { getTranslate } from '~/utils/helpers';
import { allOptionsValue } from '~/constants/main';
import { localeStore } from '~/mobx/localesStore';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types/index';

const BranchesLogHeader = (): JSX.Element => {
  const { id } = useParams<{ id?: string }>();

  const getId = (): number | null => {
    if (id && Number(id) > 0) {
      return Number(id);
    }

    return null;
  };

  const allBranchesOption = (): IPickerOption => {
    return { label: localeStore.t('reports_select_all_branches_dropdown'), value: allOptionsValue };
  };

  useEffect(() => {
    const fetchAllBranches = async () => {
      await branchStore.fetchAllBranches();
    };

    const branchId = getId();

    if (branchId) {
      branchesLogStore.setFilters({ branchIds: [branchId] });
    }

    fetchAllBranches();
  }, []);

  // For "Date" Filter
  const onSelectDate = () => {
    branchesLogStore.setFilters({ startDate: reportsStore.filters.startDate, endDate: reportsStore.filters.endDate });
  };

  // For "Branch" Filter
  const getOptions = (): IPickerOption[] => {
    return [allBranchesOption(), ...branchStore.paginationAll.data.map((branch) => ({ label: getTranslate(branch.name), value: branch.id }))];
  };

  const getDefaultOptions = (): IPickerOption[] => {
    return [allBranchesOption()];
  };

  const selectedOptions = (): IPickerOption[] => {
    const branchId = getId();

    if (!branchId) {
      return [];
    }

    const branch = branchStore.paginationAll.data.find((branch) => branch.id === branchId);

    if (branch === undefined) {
      return [];
    }

    return [{ label: getTranslate(branch.name), value: branch.id }];
  };

  const onSelectBranch = (options: IPickerOption[]) => {
    const ids = options.map((option) => option.value);
    const branchIds = ids.includes(allOptionsValue) ? undefined : ids;

    branchesLogStore.setFilters({ branchIds });
  };

  return (
    <div className="d-flex flex-row justify-content-between pr-4">
      <div className="d-flex flex-row">
        <ReportsCalendar startDate={reportsStore.filters.startDate} endDate={reportsStore.filters.endDate} onSelectDate={onSelectDate} />
        <BranchPicker
          placeholder={localeStore.t('reports_all_branches_selected_placeholder')}
          options={getOptions()}
          defaultOptions={getDefaultOptions()}
          selectedOptions={selectedOptions()}
          onSelect={onSelectBranch}
        />
      </div>
    </div>
  );
};

export default observer(BranchesLogHeader);
